import React from 'react';

import {
    ContactCard,
} from '../../promoCards/layouts/TwoThirds/contact';

export const Contact = (

) => {
    return (
        <ContactCard
            flexReverse
            title="Getting started with Metlife?"
            content="Just learning the ropes to MetLife? Here's what you need to know to get started. "
            link={{
                text: 'Get Started',
                link: '#',
            }}
            imageSource="/img/man_with_phone.png"
        />
    );
};

export default Contact;
